import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@workspace/lib';

const textareaVariants = cva(
  'border placeholder-secondary-200 bg-white outline-none focus:outline-none focus-visible:outline-none rounded-sm p-3 w-full block hover:bg-secondary-50 focus-visible:border-secondary-200 focus-within:border-secondary-200 focus-within:shadow-focus focus-visible:!bg-white',
  {
    variants: {
      status: {
        default: 'border-secondary-100 border-sm',
        error: 'border-error !border-md focus-visible:!border-sm',
        success: 'border-success border-sm',
      },
      isDisabled: {
        true: 'bg-secondary-100 cursor-not-allowed',
        false: '',
      },
    },
    defaultVariants: {
      status: 'default',
      isDisabled: false,
    },
  },
);

interface TextAreaProps {
  id?: string;
  name?: string;
  placeholder: string;
  value?: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
  status?: VariantProps<typeof textareaVariants>['status'];
  errorMessage?: string;
  onBlur?: () => void;
}

export const TextArea = ({
  id,
  name,
  placeholder,
  value = '',
  onChange,
  isDisabled = false,
  status = 'default',
  errorMessage,
  onBlur,
}: TextAreaProps) => {
  const wordCount = value ? value.length : 0;

  return (
    <div className="w-full">
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        disabled={isDisabled}
        className={cn(textareaVariants({ status, isDisabled }))}
      />
      <div className="flex justify-between items-center mt-xs">
        {errorMessage && <span className="text-xs text-error">{errorMessage}</span>}
        <span className="text-base text-secondary-700 text-right ml-auto">{wordCount}/1000</span>
      </div>
    </div>
  );
};
